import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'

@Component({

})
export default class ModalMaster extends Vue {
    style: string = 'width: 1324px; overflow:hidden;'

    @Watch('$route.query.style')
    changeStyle(val: any) {
        this.style = this.$route.query.style.toString()
    }
    created() {
        if (this.$route.query.style) {
            this.style = this.$route.query.style.toString()
        }
    }
}